import { Pipe, PipeTransform } from '@angular/core';
import { OrgRole, UserRole } from '@core/models/users';
import { rolesMap } from '../utils/roles-map';

@Pipe({ name: 'remapRole' })
export class RemapRolePipe implements PipeTransform {
  transform(value: UserRole | OrgRole, ...args: unknown[]): { en: string } {
    return rolesMap.get(value) ?? { en: 'role-not-found' };
  }
}
